export default {
  multiselect: {
    placeholder: 'Select an option',
    selectLabel: 'ENTER to select',
    selectedLabel: 'Selected',
    deselectLabel: 'none',
    noResult: 'No results found',
    noOptions: 'Whoops, no options here',
  },
}
